import { cva } from "class-variance-authority";
import {
  DateInput as AriaDateInput,
  DateSegment,
  type DateInputProps as AriaDateInputProps,
} from "react-aria-components";

import { cn } from "@beweegbaas/ui/lib/utils";

const segmentStyles = cva(
  `inline p-0.5 type-literal:px-0 rounded-xs outline outline-0
    forced-color-adjust-none caret-transparent text-foreground`,
  {
    variants: {
      isPlaceholder: {
        true: "text-muted-foreground italic",
      },
      isDisabled: {
        true: "text-muted-foreground opacity-50",
      },
      isFocused: {
        true: "bg-primary text-primary-foreground",
      },
    },
  },
);

export interface DateInputProps extends Omit<AriaDateInputProps, "children" | "className"> {
  className?: string | ((props: { isDisabled?: boolean }) => string);
}

export function DateInput({ className, ...props }: DateInputProps) {
  return (
    <AriaDateInput
      className={(renderProps) =>
        cn(
          "block min-w-[150px] px-2 py-1.5 text-sm",
          className,
          typeof className === "function" ? className(renderProps) : undefined,
        )
      }
      {...props}
    >
      {(segment) => (
        <DateSegment
          segment={segment}
          className={(renderProps) =>
            segmentStyles({
              isPlaceholder: renderProps.isPlaceholder,
              isDisabled: renderProps.isDisabled,
              isFocused: renderProps.isFocused,
            })
          }
        />
      )}
    </AriaDateInput>
  );
}
